var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Billing_svg__clip0_5150_98141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.83 6.589l-4.705-4.77a.59.59 0 00-.42-.176h-9.41a.59.59 0 00-.42.176L.17 6.589a.59.59 0 00-.024.803l9.41 10.763a.59.59 0 00.889 0l9.41-10.763a.59.59 0 00-.025-.803zm-5.372-3.765l3.54 3.59h-2.869l-1.792-3.59h1.12zm-6.475 0h4.034l1.792 3.59H6.19l1.792-3.59zm-2.44 0h1.12l-1.792 3.59H2.002l3.54-3.59zM1.89 7.594h2.96l3.037 6.86-5.997-6.86zM10 16.308L6.143 7.594h7.714L10 16.308zm2.112-1.855l3.036-6.859h2.96l-5.996 6.86z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Billing_svg__clip0_5150_98141"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/Billing.e0505b7e369e2818db29d3904907832f.svg";
export { SvgBilling as ReactComponent };